import Coverage from 'pages/benefits/coverage/Coverage';
import { CoveragePlan } from 'all-in-one-shared-api';

function HospitalisationSurgical() {
  return <Coverage coveragePlan={CoveragePlan.HOSPITALISATION} />;
}

export default HospitalisationSurgical;
